/**
 * @module actions/AudioPlayer
 */
import { AudioPlayerActions } from '../constants/AudioPlayer';
import { getNow } from '../lib/TimeUtils';

export function playTrack({ playlistId, track, currentTime = 0, isInitialLoad }) {
  return {
    type: AudioPlayerActions.AUDIO_PLAY_TRACK,
    data: {
      playlistId,
      track,
      resume: currentTime > 0,
      AUDIO_CURRENT_TIME: currentTime,
      CURRENT_TIMESTAMP: getNow(),
      isInitialLoad,
    },
  };
}

export function preloadTrack({ track }) {
  return {
    type: AudioPlayerActions.AUDIO_PRELOAD_TRACK,
    data: { track },
  };
}

export function pauseAudio({ track, isExplicit = false }) {
  return {
    type: AudioPlayerActions.PAUSE,
    data: {
      track,
      isExplicit,
    },
  };
}

export function setActiveTrackUrl(url) {
  return {
    type: AudioPlayerActions.SET_ACTIVE_TRACK_URL,
    data: {
      url,
    },
  };
}

export function scrubAudio(value = 0) {
  return {
    type: AudioPlayerActions.SCRUB_AUDIO,
    data: {
      value,
    },
  };
}

/**
 * Special action for initiating _volume change_ of the audio player. Will
 * ultimately be mapped to the global volume state.
 *
 * @param {number} volume The volume value from 0-100 inclusive on a 100 point
 * scale
 * @returns {object} The action object
 */
export function setVolumeAudio(volume) {
  return {
    type: AudioPlayerActions.SET_VOLUME,
    data: {
      volume,
    },
  };
}

/**
 * Special action for initiating _unmute_ of the audio player. Will ultimately
 * be mapped to the global muted state.
 *
 * @returns {object} The action object
 */
export function muteAudio() {
  return {
    type: AudioPlayerActions.MUTE,
  };
}

/**
 * Special action for initiating _mute_ of the audio player. Will ultimately
 * be mapped to the global muted state.
 *
 * @returns {object} The action object
 */
export function unmuteAudio() {
  return {
    type: AudioPlayerActions.UNMUTE,
  };
}

/**
 * Reset audio player
 *
 * @returns {object} The action object
 */
export function resetAudio() {
  return {
    type: AudioPlayerActions.RESET,
  };
}

export function handlePostUrlUpdate(newUrl, track) {
  return {
    type: AudioPlayerActions.HANDLE_POST_URL_UPDATE,
    data: {
      newUrl,
      track,
    },
  };
}
